import PasswordState from '../interfaces/states/PasswordState';

import * as Const from '../constants';

const initState: PasswordState = {
  passValue: '',
  error: false,
  type: 'password',
};

export default function password (state: PasswordState = initState, action): PasswordState {
  switch (action.type) {

    case Const.PASSWORD_RECEIVE_SUCCESS:
      return {
        ...state,
        passValue: action.payload,
        type: 'password',
      };
    case Const.PASSWORD_RECEIVE_FAIL:
      return {
        ...state,
        error: true,
        type: 'password',
      };
    case Const.PASSWORD_RECEIVE_INIT:
      return {
        ...state,
        passValue: '',
        error: false,
        type: 'password',
      };

    case Const.PASSWORD_TYPE_PASSWORD:
      return {
        ...state,
        type: 'password',
      };

    case Const.PASSWORD_TYPE_TEXT:
      return {
        ...state,
        type: 'text',
      };
    default:
      return state;
  }
}
